(function() {
  define('bazemont/booking/selector',['angular'], function() {
    'use strict';
    return angular.module('bazemontBookingSelector', []).component('bazemontBookingSelector', {
      templateUrl: '/assets/javascripts/bazemont/booking/selector.html',
      bindings: {
        bookingItem: '='
      },
      require: {
        bazemontBookingPageCtrl: '^^bazemontBookingPage'
      },
      controller: [
        '$http', function($http) {
          var vm;
          vm = this;
          vm.$onInit = function() {
            return $http.get('/api/booking/items').then(function(response) {
              return vm.items = response.data;
            });
          };
          vm.getLabel = function(item) {
            var label;
            label = item.longName;
            if (item.isLocalOnly) {
              label += ' (Bazemontais uniquement)';
            }
            return label;
          };
          vm.changeItem = function() {
            return vm.bazemontBookingPageCtrl.changeBookingItem(vm.bookingItem);
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=selector.js.map
;
